module.exports = __webpack_public_path__ + "img/室外感測器.85c24bca.jpg";